import { Component, OnInit, Inject } from '@angular/core';
import { ViewEventDeletionsService } from '../../../services/view-event-deletions.service';
import moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommentRendererComponent } from 'src/app/core/grid-renderer/comment.grid-renderer';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-view-event-deletions',
  templateUrl: './view-event-deletions.component.html',
  styleUrls: ['./view-event-deletions.component.scss'],
  standalone: false // NOSONAR
})
export class ViewEventDeletionsComponent implements OnInit {
  res: [];
  currentPage1: number;
  totalPageNm1: number;
  successMessage: any;
  errorMessage: any;
  public gridApi: any;
  public domLayout: any = '';
  defaultColDef: {};
  icons: {};
  columnDefs = [
    {
      headerName: 'CHANGE TYPE', field: 'changetype',
      cellStyle: this.cellStyle,
      minWidth: 100, maxWidth: 150,
    },
    { headerName: 'EVENT TYPE', field: 'eventtype', minWidth: 100, maxWidth: 130, },
    { headerName: 'REGION', field: 'region', minWidth: 70, maxWidth: 90, },
    { headerName: 'ROUTE', field: 'route', minWidth: 90, maxWidth: 100, },
    { headerName: 'U/L', field: 'ul', minWidth: 130, maxWidth: 150, valueFormatter: this.dateFormatter, },
    { headerName: 'ETA', field: 'eta', minWidth: 130, maxWidth: 150, valueFormatter: this.dateFormatter, },
    {
      headerName: '  COMMENTS', field: 'comments', minWidth: 240, maxWidth: 270, cellStyle: { cursor: 'pointer' },
      cellRendererFramework: CommentRendererComponent,
    },
    { headerName: '  DELETED DATE', field: 'deleteddate', minWidth: 130, maxWidth: 150, valueFormatter: this.dateFormatter, },
    { headerName: '  DELETED BY', field: 'deletedby', minWidth: 100, maxWidth: 120, },
  ];

  rowData: any[] = [];
  paginationPageSize: any = 10;
  displayRowData: any[] = [];
  rowCount1: number = 0;
  isLastPageFound!: boolean;
  totalPage: number = 0;
  currentPageForTotalPage!: number;
  currentPageNo: number = 1;
  currentPageBoolean: boolean = false;
  rowClassRules: { 'row-even': string; 'row-odd': string; };


  constructor(public dialogRef: MatDialogRef<ViewEventDeletionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly viewEventDeletionsService: ViewEventDeletionsService,
    private readonly ngxUiLoaderService: NgxUiLoaderService) {

    this.defaultColDef = {
      suppressMovable: true,
      wrapText: true,
      wrapHeaderText: true,
      suppressPaginationPanel: true,
      autoHeight: true,
      suppressHorizontalScroll: true,
    }

    this.icons = {
      sortUnSort: '<img src="assets/images/Icon awesome-sort.svg">',
    };
    this.rowClassRules = {
      'row-even': 'node.rowIndex % 2 == 0', // NOSONAR
      'row-odd': 'node.rowIndex % 2 != 0', // NOSONAR
    };
  }

  ngOnInit(): void {
    this.loadData();
  }

  /* onPaginationChanged() {
    
    if (this.gridApi) {
      
      this.setText('#lbCurrentPage', this.gridApi.paginationGetCurrentPage() + 1);
      this.setText('#lbTotalPages', this.gridApi.paginationGetTotalPages());
      this.setLastButtonDisabled(!this.gridApi.paginationIsLastPageFound());
    }
  } */

  /*  setText(selector: string, text: any) {
     if(this.rowCount>0){
       (document.querySelector(selector) as any).innerHTML = text;
     }
   }

   setLastButtonDisabled(_disabled: boolean) {
     this.isLastPageFound = true;
   }

   isLastPage(): boolean {
     this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
     this.currentPageForTotalPage = Number(this.gridApi?.paginationGetCurrentPage()) + 1;
     if (this.totalPage == this.currentPageForTotalPage) {
       this.isLastPageFound = true;
     }
     else {
       this.isLastPageFound = false;
     }
     return this.isLastPageFound;
   } */

  /* goToLastPage() { return this.gridApi.paginationGoToLastPage()  }
  goToNexpage() { this.gridApi.paginationGoToNextPage()}
  goToPreviousPage() { return this.gridApi.paginationGoToPreviousPage()}
  goToFirstPage() { this.gridApi.paginationGoToFirstPage() }
  getCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) {
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false; }
    return this.currentPageBoolean;
  } */

  dateFormatter(params) {
    return params.value ? moment(params.value).format('MM/DD/YYYY HH:mm') : null;
  }

  loadData() {
    this.successMessage = null;
    this.errorMessage = null;
    this.rowData = [];
    this.ngxUiLoaderService.start('loader-1');
    this.viewEventDeletionsService.loadEventDeletionsData().subscribe(res => {
      this.ngxUiLoaderService.stop('loader-1');
      const tableData = res;
      const typeMap = new Map<number, string>();
      typeMap.set(1, 'BlowOut');
      typeMap.set(2, 'Late Route');
      typeMap.set(3, 'Shortage');
      typeMap.set(4, 'Preemptive');
      typeMap.set(5, 'Dropped Route');
      tableData.forEach(row => {
        row.data = JSON.parse(row.data);

        let changeTypeValue = '';

        if (row.changeType == 'D') { // NOSONAR
          changeTypeValue = 'DELETED';
        }

        const eventTypeId =
          row.data?.event_type_id ?? row.data?.eventTypeId;

        const deletedDate =
          row.data?.last_updated ?? row.data?.lastUpdated ?? '';

        const deletedBy =
          row.data?.last_updated_by ?? row.data?.lastUpdatedBy ?? '';

        const obj = {
          changetype: changeTypeValue,
          eventtype: row.data ? typeMap.get(eventTypeId) ?? '' : '',
          region: row.data?.region ?? '',
          route: row.data?.puroute ?? '',
          ul: row.data?.arrival ?? '',
          eta: row.data?.eta ?? '',
          comments: row.data?.comments ?? '',
          deleteddate: deletedDate,
          deletedby: deletedBy
        };

        this.rowData.push(obj);
      });

      this.rowData = [...this.rowData];
      this.rowCount1 = this.rowData.length;
    },
      err => {
        this.ngxUiLoaderService.stop('loader-1');
        console.info(err);
      });
  }

  /* onPageSizeChanged(event: any) {
    if (event.target.value == "ALL"){
      this.paginationPageSize = event.target.value;
      this.gridApi?.paginationSetPageSize(Number(this.displayRowData.length));
    }else{
      this.paginationPageSize = event.target.value;
      this.gridApi?.paginationSetPageSize(Number(event.target.value));
    }
  } */

  /* sizeToFit() { this.gridApi?.sizeColumnsToFit() } */

  cellStyle(_params: any) {
    return { 'display': 'flex', 'justify-content': 'center', 'background-color': '#D20000', 'color': '#FFFFFF', 'border-radius': '25px', 'margin': '0 10px', 'max-width': 'fit-content', 'font-size': '11px', 'height': '20px' };
  }

  onNoClick(): void {
    this.dialogRef.close();
  }


  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  sizeToFit() { this.gridApi?.sizeColumnsToFit() }
  goToNexpage() { this.gridApi?.paginationGoToNextPage() }
  goToPreviousPage() { this.gridApi?.paginationGoToPreviousPage() }
  goToFirstPage() { this.gridApi?.paginationGoToFirstPage() }
  goToLastPage() { this.gridApi?.paginationGoToLastPage() }

  getCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) { // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false; }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) { // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }

  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") { // NOSONAR
      this.paginationPageSize = event.target.value;
      this.gridApi?.paginationSetPageSize(Number(this.rowData.length));
    } else {
      this.paginationPageSize = event.target.value;
      this.gridApi?.paginationSetPageSize(Number(event.target.value));
    }
  }

  onPaginationChanged() {

    if (this.gridApi!) {
      this.setText('#lbCurrentPage1', this.gridApi.paginationGetCurrentPage() + 1);
      this.setText('#lbTotalPages1', this.gridApi.paginationGetTotalPages());
      this.setLastButtonDisabled(!this.gridApi.paginationIsLastPageFound());
    }
  }

  setText(selector: string, text: any) {

    if (this.rowCount1 > 0) {

      (document.querySelector(selector) as any).innerHTML = text;
      if (selector == '#lbCurrentPage1') { // NOSONAR
        this.currentPage1 = text
      }
      else {
        this.totalPageNm1 = text;
      }
    }
  }
  setLastButtonDisabled(_disabled: boolean) {
    this.isLastPageFound = true;
  }

  /* onGridReady(params:any) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
    //this.gridApi.setDomLayout("autoHeight");
  } */
}
export interface EventDetails {
  billingHistoryId: number;
  recordType: string;
  recordId: number;
  data: string;
  updatedBy: string;
  updatedTime: string;
  changeType: string;

}